import React from 'react';
import { Copy, Trash2, Split, MoreVertical } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface ManualEntryInlineActionsProps {
  onDuplicate: () => void;
  onDelete: () => void;
  onSplit?: () => void;
  disabled?: boolean;
  canSplit?: boolean;
}

export const ManualEntryInlineActions: React.FC<ManualEntryInlineActionsProps> = ({
  onDuplicate,
  onDelete,
  onSplit,
  disabled = false,
  canSplit = true,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          disabled={disabled}
          className="h-8 w-8 hover:bg-accent text-muted-foreground hover:text-foreground"
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onDuplicate} disabled={disabled}>
          <Copy className="h-4 w-4 mr-2" />
          Duplicate
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={onDelete} 
          disabled={disabled}
          className="text-destructive focus:text-destructive"
        >
          <Trash2 className="h-4 w-4 mr-2" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
